import { h, Component } from 'preact';
import cx from 'classnames';
import dlv from 'dlv';

import style from './style.less';

import CardImage from '../../pieces/card-image';
import { isExternal } from '../../../lib/utils';

import { trackingProvider, trackProps, getTrackingAttributesForAsset, DIMENSION } from '@cube/track';
import { assetLink } from '@cube/utils';

import { Text } from 'preact-i18n';

/**
 * A card with an image with overlayed text
 * Layout
 * Image with title and attribution and button overlayed
 * @param {Object} asset content for a card
 */
@trackingProvider({
	[DIMENSION.componentpath]: 'FullImageTextOverlayCard'
})
export default class FullImageTextOverlayCard extends Component {

	Overlay = () => (
		<div class={style.overlay}>
			<div class={style.source}>{dlv(this.props, 'asset.metadata.attribution.vendor')}</div>
			<div class={style.title}>{dlv(this.props, 'asset.title')}</div>
			<a class={style.readLink}>
				{ dlv(this.props, 'asset.videos.0') ?
					<Text id="watch" /> :
					<Text id="read" />
				}
			</a>
		</div>
	);

	render({ asset, theme, cardClass, qeId, ...props }) {
		return (
			<div data-tb-region-item class={cx(style.fullImageTextOverlayCard, cardClass)} qid={qeId}>
				<a
					{...trackProps(getTrackingAttributesForAsset(asset), this.context)}
					href={assetLink(asset)}
					rel={isExternal(asset) && 'noreferrer noopener'}
					target={isExternal(asset) && '_blank'}
				>
					<CardImage
						asset={asset}
						iconPosition="none"
						qeId={qeId}
						{...props}
						Overlay={this.Overlay}
					/>

				</a>
			</div>
		);
	}
}
